<!-- dlg-confirm.component.html -->
<div class="fixed inset-0 bg-gray-700 bg-opacity-75 flex justify-center items-center z-50 no-scrollbar">
    <div class="bg-white shadow-lg rounded p-4 max-w-md w-full relative">

        <!-- Header: Title + Close X -->
        <div class="flex flex-row justify-between items-center mb-4">
            <h1 class="font-bold text-xl">{{ title }}</h1>
            <button type="button" (click)="onCancel()" class="text-gray-300 hover:text-gray-500 focus:outline-none">
                <i class="fas fa-xmark text-xl"></i>
            </button>
        </div>

        <!-- Icon + Message -->
        <div class="flex flex-row gap-4 items-center my-4 mx-2">
            @switch (showType) {
            @case (alertType.error) {
            <i class="fas text-4xl fa-circle-xmark text-red-400"></i>
            }
            @case (alertType.success) {
            <i class="fas text-4xl fa-circle-check text-green-700"></i>
            }
            @case (alertType.warning) {
            <i class="fas text-4xl fa-triangle-exclamation text-yellow-500"></i>
            }
            @case (alertType.info) {
            <i class="fas text-4xl fa-circle-question text-blue-500"></i>
            }
            @default {
            <i class="fas text-4xl fa-circle-question text-blue-500"></i>
            }
            }
            <div class="text-left overflow-hidden min-w-0">
                <p class="text-primary-300 text-sm break-words whitespace-normal" [innerHTML]="description"></p>
            </div>
        </div>
        <div class="flex flex-row gap-4 justify-end">
            @if (showCancel) {
            <button type="button" (click)="onCancel()" class="text-primary-500 px-4 py-2 focus:outline-none">{{
                cancelText }}</button>
            }
            <button type="button" (click)="submit()"
                class="{{ showType == alertType.warning ? 'bg-red-500' : buttonColor }} {{ buttonTextColor }} rounded font-semibold px-4 py-2 focus:outline-none">
                {{ action }}
            </button>
        </div>

    </div>
</div>